import LectureLessonLecturerResourceModel from '../../generated/types/model/resource/LectureLessonLecturerResourceModel';

export default class LectureLessonLecturerResourceViewModel extends LectureLessonLecturerResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
